export default __webpack_public_path__ + "static/media/IMG_8431.865d2a96.jpg";